import styled from "styled-components/macro";

const largeIconDimensions = "96";
const regularIconDimensions = "24";
const smallIconDimensions = "16";
interface SvgProps {
    svgFill?: string;
    svgStroke?: string;
    pathStroke?: string;
    pathFill?: string;
    svgbackgroundColor?: string;
    isLargeIcon?: boolean;
    rotateIcon?: string;
    isSmallIcon?: boolean;
}

export const SvgWrapper = styled.div<SvgProps>`
    height: ${(props) =>
        props.isLargeIcon
            ? largeIconDimensions
            : props.isSmallIcon
            ? smallIconDimensions
            : regularIconDimensions}px;
    width: ${(props) =>
        props.isLargeIcon
            ? largeIconDimensions
            : props.isSmallIcon
            ? smallIconDimensions
            : regularIconDimensions}px;
    background-color: ${(props) => props.svgbackgroundColor};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(${(props) => props.rotateIcon});
    transition: transform 0.3s ease;

    svg {
        fill: ${(props) => props.svgFill};
        stroke: ${(props) => props.svgStroke};

        path,
        circle {
            fill: ${(props) => props.pathFill};
            stroke: ${(props) => props.pathStroke};
        }
    }
`;
